<template>
  <v-row>
      <v-col cols="12">
        <h2 v-text="detailKey" />
        <v-simple-table
          v-if="detailValue && typeof detailValue === 'object' && Object.keys(detailValue).length > 0"
        >
          <template #default>
            <thead>
              <tr>
                <th class="text-left" v-text="$t('monitoring.details.key')" />
                <th class="text-left" v-text="$t('monitoring.details.value')" />
              </tr>
            </thead>
            <tbody>
              <tr v-for="key in Object.keys(detailValue)" :key="key" >
                <td v-text="key" />
                <td v-text="detailValue[key]" />
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <p v-else v-text="detailValue" />
      </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'Details',
  props: {
    detailValue: [String, Boolean, Number, Object],
    detailKey: String
  }
}
</script>
